import { asyncData as searchBarAsyncData } from '../md-search-bar/asyncData';
import * as TYPES from './_store/constants';

export async function asyncData(store) {
    await searchBarAsyncData.call(this, store, {
        listingSource: 'sold listings',
        block: 'snapshot'
    });
    const condition = store.searchParamsWithMap;
    delete condition.listingSource;
    store[TYPES.UPDATE_SEARCH_PARAMS](condition);
}

export async function fetchMarketReportData(store) {
    await store[TYPES.FETCH_MARKET_REPORT_DATA]();
}
